export default __webpack_public_path__ + "static/media/projectSectionImage.6683187b.jpg";